import ListAltIcon from '@mui/icons-material/ListAlt'
import GppBadIcon from '@mui/icons-material/GppBad'
import { NavigationRoute, NavigationRouteWithChildren } from '../types/navigation-meny-types'

export const navigationMenuRoutes: (NavigationRouteWithChildren | NavigationRoute)[] = [
  { route: '/rides', permissions: true, label: 'Rides', icon: <ListAltIcon /> },
  { route: '/permissions', permissions: 'permissions.view', label: 'Permissions', icon: <GppBadIcon /> }
]

